import AsSeenOn from 'components/home-page-2026/as-seen-on';
import Hero from 'components/home-page-2026/hero';
import HowItWorks from 'components/home-page-2026/how-it-works';
import Prizes from 'components/home-page-2026/prizes';
import QuickAnswers from 'components/home-page-2026/quick-answers';
import Trees from 'components/home-page-2026/trees';
import Winners from 'components/home-page-2026/winners';
import MainLayout from 'components/layout/MainLayout';

export interface HomePageV1Props {
  nextDrawDate: string;
  withCountdown?: boolean;
  prizes: HomePagePrize[];
}

export interface HomePagePrize {
  title: string;
  imageSrc: string;
  imageAlt: string;
  mainCategory: string;
  href: string;
}

const HomePageV1 = ({
  withCountdown,
  nextDrawDate,
  prizes,
}: HomePageV1Props) => {
  return (
    <MainLayout
      limitItemWidths
      clearHeader
      displayHeaderOnScroll
      footerBackground="absoluteWhite"
    >
      <div className="daymadeTypographyReset">
        <Hero withCountdown={withCountdown} nextDrawDate={nextDrawDate} />
        <AsSeenOn />
        <Prizes prizes={prizes} />
        <HowItWorks />
        <Winners />
        <Trees />
        <QuickAnswers />
      </div>
    </MainLayout>
  );
};

export default HomePageV1;
